import { render, staticRenderFns } from "./AdminModal.vue?vue&type=template&id=3e2ef824&scoped=true"
import script from "./AdminModal.vue?vue&type=script&lang=js"
export * from "./AdminModal.vue?vue&type=script&lang=js"
import style0 from "./AdminModal.vue?vue&type=style&index=0&id=3e2ef824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2ef824",
  null
  
)

export default component.exports